import { render, staticRenderFns } from "./tab-five.vue?vue&type=template&id=cb63aec4&"
import script from "./tab-five.vue?vue&type=script&lang=ts&"
export * from "./tab-five.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports